module.exports = __webpack_public_path__ + "static/media/sylvia.f5473c90.png";